import { Injectable } from '@angular/core';

function getWindow(): any {
	return window;
}

@Injectable({
	providedIn: 'root'
})
export class WindowRefService {
	/**
	 * Get browser window
	 */
	get nativeWindow(): any {
		return getWindow();
	}

	/**
	 * Get (new) tab
	 */
	getTab(url: string = this.baseUrl + 'external/loading', target: string = '_blank') {
		return this.nativeWindow.open(url, target);
	}

	/**
	 * open URL in current window
	 *
	 * @param url
	 */
	openUrl(url): boolean {
		if (!this.nativeWindow.name) {
			this.nativeWindow.name = 'cfe-main';
		}
		// return false;
		return !!this.nativeWindow.open(url, this.nativeWindow.name);
	}

	/**
	 * Get a new tab
	 */
	get newTab() {
		return this.getTab();
	}

	/**
	 * Get base URL
	 */
	get baseUrl() {
		return document.getElementsByTagName('base')[0].href;
	}
}
